export default {
  ticket: null,
  topic: null,
  percent: 0,
  uploading: false,
  processing: false,
  error: null,
  success: null,
};
